// import axios from 'axios'
import apiConfig from '../config/api'
import configLoader from '../config/loader'
import RequestService from '../services/request.service'

const SESSION_FIELDS = ['email', 'username', 'token', 'loginState', 'timestamp']

export interface UserSession {
  loginState: boolean
  username: string
  email: string
  token: string
  timestamp: number
}

export default class SessionService implements UserSession {
  loginState = false
  username = ''
  email = ''
  token = ''
  timestamp = 0
  config: any = null

  private static instance: SessionService

  static Instance(): SessionService {
    if (!this.instance) {
      this.instance = new SessionService()
    }
    return this.instance
  }

  static copy(source: UserSession, target: UserSession) {
    target.loginState = source.loginState
    target.token = source.token
    target.username = source.username
    target.email = source.email
  }

  private constructor() {
    let sessionData = this.getSessionInstance()
    SessionService.copy(sessionData, this)
  }

  isLogin() {
    return !!this.readSessionItem('loginState')
  }

  login(email: string, password: string) {
    let payload: any = {
      success: false,
      error: '',
      code: 'success',
      data: null,
    }
    const serverConfig = configLoader.loadServerConfig()

    const httpClient = RequestService.Instance().getClient()
    return httpClient
      .request({
        method: 'post',
        host: serverConfig.host,
        url: apiConfig.api.login,
        data: {
          email,
          password,
        },
      })
      .then((response: any) => response.data)
      .then((response: any) => {
        if (response.status === 0) {
          this.setToken({
            username: response.data.admin.username,
            email,
            timestamp: Date.now(),
            token: response.data.token,
            loginState: true,
          })

          payload = Object.assign({}, payload, {
            data: {
              token: response.data.token,
              email,
              username: response.data.admin.username,
              loginState: true,
            },
            success: true,
          })
        } else {
          this.loginState = false
          payload.error = response.msg
        }
        payload.code = response.code
        return payload
      })
  }

  // logout() {
  //   return this.http
  //     .post<any>(systemConfig.host + systemConfig.api.logout, null, {
  //       headers: Object.assign({}, this.getAuthHeader()),
  //     })
  //     .toPromise()
  //     .then((response) => {
  //       this.clearSession()
  //       return true
  //     })
  // }

  setToken(authData: any) {
    SessionService.copy(authData, this)
    SESSION_FIELDS.forEach((key) => {
      this.putSessionItem(key, authData[key])
    })
  }

  getToken() {
    return this.readSessionItem('token')
  }

  getAuthHeader() {
    let token = this.getToken()
    return {
      Authorization: `Bearer ${token}`,
    }
  }

  clearSession() {
    SESSION_FIELDS.forEach((key) => {
      window.sessionStorage.removeItem('ai-ops:' + key)
    })
  }

  putSessionItem(key: string, value: object) {
    window.sessionStorage.setItem('ai-ops:' + key, JSON.stringify(value))
  }

  readSessionItem(key: string) {
    const keyStr = window.sessionStorage.getItem('ai-ops:' + key)
    return keyStr ? JSON.parse(keyStr) : ''
  }

  getSessionInstance(): UserSession {
    const target: any = {}

    SESSION_FIELDS.forEach((key) => {
      target[key] = this.readSessionItem(key)
    })

    return target
  }
}
